<template>
  <div class="container-fluid page-container">
    <div class="row m-auto col-md-9 px-0 shadow rounded">
      <div v-html="pageTitle" />
      <b-card-body class="p-3 d-block" v-html="pageContent" />
    </div>
  </div>
</template>

<script>
import company from "@/imports/mixins/company";

export default {
  name: "Ideal",
  mixins:[company],
  data() {
    return {
      contentKey: 'ideal-rewards',
      pageContent: null,
      pageTitle: 'More Benefits With Boiler Guide & Ideal Heating',
    }
  },
  methods: {
    getPageContent() {
      const communicationsLanguage = this.company?.communications_language?.iso_code ?? 'en';
      this.$api.page.getPageContent(communicationsLanguage).then((response) => {
        const responseData = response.data;
        let content = responseData.find(page => page.url === this.contentKey);
        this.pageTitle = content.title;
        this.pageContent = content.body;
      });
    }
  },
  mounted() {
    this.getPageContent();
  }
}
</script>

<style scoped>

</style>
